module.exports = __webpack_public_path__ + "static/img/tab.e1e7f1a5.svg";